import React from "react";
import Nav from "../../components/Home/Nav";
import Slider from "../../components/Home/Slider";
import Footer from "../../components/Home/Footer";
import { Fade } from "react-awesome-reveal";
import {
  HiArrowRight,
  HiShieldCheck,
  HiStar,
  HiUsers,
  HiLightningBolt,
} from "react-icons/hi";
import { FaEnvelope , FaLinkedin } from "react-icons/fa";

function HomePage() {
  return (
    <div className="bg-slate-50 min-h-screen">
      <Nav />
      <Slider />

      {/* Hero Content Section */}
      <section className="py-12 md:py-20 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-black text-slate-900 leading-[1.2] lg:leading-[1.1] mb-8 tracking-tight">
              Building <span className="text-blue-600">Data and Artificial Intelligence </span>{" "}
              Solutions for Decade!!!
            </h1>
            <div className="flex gap-4 mb-8">
              <div className="w-1.5 bg-blue-600 rounded-full"></div>
              <p className="text-base md:text-lg text-slate-600 leading-relaxed font-medium">
               My experience with data, software and AI to build solutions that matter
              </p>
            </div>
            <div className="flex flex-wrap gap-4">
              <a
                href="/homeServices"
                className="px-6 md:px-8 py-3.5 md:py-4 bg-blue-600 text-white rounded-2xl font-bold hover:bg-blue-700 transition-all shadow-xl shadow-blue-200 hover:-translate-y-1 flex items-center gap-2 text-sm md:text-base"
              >
                Explore Services <HiArrowRight />
              </a>
              <a
                href="/portfolio"
                className="px-6 md:px-8 py-3.5 md:py-4 bg-white text-slate-700 border border-slate-200 rounded-2xl font-bold hover:bg-slate-50 transition-all hover:-translate-y-1 text-sm md:text-base"
              >
                Explore Projects
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section
        className="py-16 md:py-24 bg-white relative overflow-hidden"
        id="about-us"
      >
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          <div className="space-y-6 order-2 md:order-1">
            <p className="text-blue-600 font-black uppercase tracking-[0.2em] text-[10px] md:text-sm">
              Software | Data | AI | and Cloud expertise
            </p>
            <h2 className="text-2xl md:text-5xl font-black text-slate-900 tracking-tight leading-tight">
              Experience the pinnacle of engineering excellence
            </h2>
            <p className="text-base md:text-lg text-slate-600 leading-relaxed font-medium">
              Software, data, AI, and cloud expertise converge to form the backbone of modern digital infrastructure. Software engineering builds the application logic, data expertise manages and structures information, AI introduces intelligent automation, and cloud platforms provide the scalable compute power required to run everything reliably
            </p>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}

export default HomePage;
